import React from 'react';

const IcErrorFill = () => {
    return (
        <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_3079_7222)'>
                <path d='M16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8Z' fill='#F4C10B' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8.50003 3.55566C8.00911 3.55566 7.61114 3.95363 7.61114 4.44455C7.61114 4.93547 8.00911 5.33344 8.50003 5.33344C8.99095 5.33344 9.38892 4.93547 9.38892 4.44455C9.38892 3.95363 8.99095 3.55566 8.50003 3.55566ZM7.16666 6.48899C6.82301 6.48899 6.54443 6.76756 6.54443 7.11121C6.54443 7.45485 6.82301 7.73343 7.16666 7.73343H7.87763L7.87763 10.9334H7.16666C6.82301 10.9334 6.54443 11.212 6.54443 11.5557C6.54443 11.8993 6.82301 12.1779 7.16666 12.1779H9.83332C10.177 12.1779 10.4555 11.8993 10.4555 11.5557C10.4555 11.212 10.177 10.9334 9.83332 10.9334H9.12207L9.12207 7.12459L9.12221 7.11121C9.12221 6.76756 8.84363 6.48899 8.49999 6.48899H7.16666Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id='clip0_3079_7222'>
                    <rect width='16' height='16' fill='white' transform='translate(0.5)' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IcErrorFill;
